import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AmbassadorDelivery } from "../../../domain/entities/team";
import { type TeamDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const listDeliveries = createAsyncThunk<
  AmbassadorDelivery[],
  { ambassadorId: string; from: string; to: string },
  { dispatch: TeamDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.LIST_DELIVERIES, async ({ ambassadorId, from, to }, { extra }) => {
  return await extra.teamRepo.listDeliveries(ambassadorId, from, to);
});
